// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import Map from 'ol/Map';
import View from 'ol/View';
import { XYZ } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import { fromLonLat } from 'ol/proj';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { Icon, Style } from 'ol/style';

interface DprMiniMapProps {
  lat: number | null;
  lon: number | null;
  height?: string | number;
}

const DprMiniMap: React.FC<DprMiniMapProps> = ({ lat, lon, height = '300px' }) => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<any>(null);
  const vectorSourceRef = useRef<any>(null);

  useEffect(() => {
    if (!mapRef.current) return;

    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    vectorSourceRef.current = vectorSource;

    const satelliteLayer = new TileLayer({
      source: new XYZ({
        url: 'https://mt{0-3}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        attributions: '© Google Maps',
        wrapX: true
      }),
      visible: true,
    });

    const initialLon = lon ?? 0;
    const initialLat = lat ?? 0;

    const olMap = new Map({
      target: mapRef.current,
      layers: [satelliteLayer, vectorLayer],
      view: new View({
        center: fromLonLat([initialLon, initialLat]),
        zoom: lat != null && lon != null ? 6 : 1,
        minZoom: 0,
        maxZoom: 18,
      }),
      controls: [], // Remove default controls to keep it minimal
    });

    setMap(olMap);

    return () => {
      olMap.setTarget(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run once on mount

  useEffect(() => {
    if (!map || !vectorSourceRef.current) return;

    const source = vectorSourceRef.current;
    source.clear();

    if (lat != null && lon != null) {
      const feature: any = new Feature({
        geometry: new Point(fromLonLat([lon, lat])),
      });

      feature.setStyle(
        new Style({
          image: new Icon({
            src: '/media/map/marker.svg',
            scale: 0.9,
            anchor: [0.5, 0.5],
            crossOrigin: 'anonymous',
          }),
        })
      );

      source.addFeature(feature);

      map.getView().animate({
        center: fromLonLat([lon, lat]),
        zoom: 6, // Keep zoom steady to not zoom in too crazy
        duration: 800,
      });
    }
  }, [map, lat, lon]);

  return (
    <div style={{ height, width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #dee2e6' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
    </div>
  );
};

export default DprMiniMap;
